import type { FC } from 'react';

import { IconPerson } from 'icons';
import { cn } from '@/lib/utils';

import { toInitials } from 'utils/initials';

import type { TAvatarProps } from './Avatar.props';

import { avatarVariants } from './Avatar.variants';

const Avatar: FC<TAvatarProps> = ({
  tone, size, name, glyph, className, ...rest
}) => {
  const initials = name && !glyph ? toInitials(name) : '';

  const isLabelled = Boolean(name);

  return (
    <span
      role={isLabelled ? 'img' : undefined}
      aria-label={name}
      aria-hidden={isLabelled ? undefined : true}
      className={cn(avatarVariants({ tone, size }), className)}
      {...rest}
    >
      {initials || (
        <span className="text-icon-placeholder flex size-4 items-center justify-center">
          {glyph ?? <IconPerson />}
        </span>
      )}
    </span>
  );
};

export {
  Avatar,
};
